export default {
    methods: {
        indicateScrollability() {
            this.$nextTick(() => {
                if (!this.$refs.options) {
                    return
                }

                const initialScrollTop = this.$refs.options.scrollTop
                this.$refs.options.scrollTo(0, initialScrollTop + 1)
                this.$refs.options.scrollTo(0, initialScrollTop)
            })
        },
    },

    watch: {
        isOpen(isOpen) {
            if (isOpen) {
                this.indicateScrollability()
            }
        },
    },
}
